module.exports = __webpack_public_path__ + "img/plus-circle-fill.78801e86.svg";